import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import { ListagemGestantePuerperaMedicoesModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSectionProps {
  medicoesPreNatal: ListagemGestantePuerperaMedicoesModel
  iconColor?: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection({
  medicoesPreNatal,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='rulerFilled' color={iconColor} />
          <Text fontWeight='bold'>Medições (quantidade)</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Registros de altura uterina</Text>
          <Text>{medicoesPreNatal?.qtdMedicoesAlturaUterina ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Registros de pressão arterial</Text>
          <Text>{medicoesPreNatal?.qtdMedicoesPressaoArterial ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Registros de peso e altura simultâneos</Text>
          <Text>{medicoesPreNatal?.qtdMedicoesPesoAltura ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
